import { Avatar, Divider, Modal } from "antd";
import Button from "Components/Button";
import Input from "Components/Input";
import Loader from "Components/Loader";
import { useGetDriverOrdersQuery } from "hooks/Driver/useGetDriverOrdersQuery";
import { useMarkAsDelivered } from "hooks/Driver/useMarkAsDelivered";
import { useMarkAsPickedUp } from "hooks/Driver/useMarkAsPickedUp";
import DriverDashboard from "Layout/DriverDashboard";
import { Status } from "Pages/User/OrderManagement/Components/Status";
import { useEffect, useState } from "react";
import Moment from "react-moment";
import { useNavigate, useParams } from "react-router-dom";
import { Boxes } from ".";

const DriverOrderDetails = () => {
  const { id } = useParams();
  const [isModalOpen, setIsModal] = useState(false);
  const [otp, setOtp] = useState("");
  const { data: orderProducts, isLoading } = useGetDriverOrdersQuery({
    id: id ? id : "",
  });

  const navigate = useNavigate();

  const { mutateAsync: handleDelivered, isPending: isDelivering } =
    useMarkAsDelivered({
      id: id ? id : "",
    });
  const { mutateAsync: handlePickup, isPending } = useMarkAsPickedUp();

  const [pending, setPending] = useState(false);

  const pickup = () => {
    setPending(true);
    handlePickup(id);
    // alert("pickedup");
  };

  useEffect(() => {
    if (isPending) {
      setPending(true);
    }
  }, [isPending]);

  useEffect(() => {
    if (isDelivering) {
      setPending(true);
    }
  }, [isDelivering]);

  const deliver = () => {
    handleDelivered(otp, {
      onSuccess: () => {
        setIsModal(false);
        navigate("/driver/orders");
      },
    });
  };

  return (
    <DriverDashboard title="Order Details" back>
      <div>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="flex flex-row gap-3 py-3">
              <Boxes />
              <div className="flex-1">
                <div>
                  <h3>{orderProducts?.data?.orderNo}</h3>
                  <Moment
                    interval={0}
                    format="DD-MM-YYYY hh:mm a"
                    className="text-[#939393] text-[13px]"
                  >
                    {orderProducts?.data?.createdAt}
                  </Moment>
                </div>
              </div>
              <span className="w-[80px]">
                <span>
                  {orderProducts?.data?.statusLogs && (
                    <Status
                      value={orderProducts?.data?.statusLogs.at(-1)?.status}
                    />
                  )}
                </span>
              </span>
            </div>
            <Divider />
            <h3 className="text-[13px] font-bold mb-3">Product Information</h3>
            <div>
              {orderProducts?.data?.orderProducts?.map(
                ({
                  id,
                  createdAt,
                  image,
                  productName,
                  unit,
                  measurement,
                }: {
                  id: string;
                  createdAt: string;
                  productName: string;
                  image: string;
                  unit: number;
                  measurement: string;
                }) => (
                  <div
                    key={id}
                    className="flex flex-row items-center gap-3 mb-4"
                  >
                    <img
                      src={image}
                      alt=""
                      className="h-[45px] w-[45px] rounded-[5px]"
                    />
                    <div className="flex-1">
                      <h3 className="font-medium text-[13px]">
                        {productName}{" "}
                      </h3>
                      <div className="text-[12px] text-[#939393] mt-[3px]">
                        Quantity: {unit}X
                      </div>
                      <div className="text-[12px] text-[#939393] mt-[3px]">
                        Measurement: {measurement}
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
            <Divider />
            <h3 className="text-[13px] font-bold mb-3">Customer Details</h3>
            <div className="flex flex-row gap-3 py-3">
              <Avatar
                style={{
                  backgroundColor: "#562B00",
                  verticalAlign: "middle",
                }}
                size="large"
              >
                {orderProducts?.data?.customerName &&
                  orderProducts?.data?.customerName.charAt(0)}
              </Avatar>

              <div className="flex-1">
                <h3 className="text-[13px] font-medium">
                  {orderProducts?.data?.customerName}
                </h3>
                <p className="text-[#939393] text-[13px]">
                  {orderProducts?.data?.customerEmail}
                </p>
              </div>
            </div>
            <Divider />
            <a
              href={`tel:${orderProducts?.data?.customerPhone}`}
              className="flex-1 flex items-center gap-2"
            >
              <span className="w-[45px] h-[45px] rounded-md flex justify-center items-center bg-primary-light">
                <PhoneIcon />
              </span>
              {orderProducts?.data?.customerPhone}
            </a>
            <Divider />
            <h3 className="text-[13px] font-bold mb-3">Shipping Address</h3>
            <p className="text-[13px] pb-[40px]">
              {orderProducts?.data?.customerAddress}
            </p>
            {orderProducts?.data?.statusLogs &&
              orderProducts?.data?.statusLogs.at(-1)?.status === "shipped" && (
                <Button
                  onClick={pickup}
                  disabled={pending}
                  isLoading={isLoading}
                  label={"Mark as picked up"}
                />
              )}
            {orderProducts?.data?.statusLogs &&
              orderProducts?.data?.statusLogs.at(-1)?.status === "transit" && (
                <Button
                  onClick={() => setIsModal(true)}
                  // disabled={!payload?.email || !payload?.password}
                  isLoading={isLoading}
                  label={"Mark as Delivered"}
                />
              )}
          </>
        )}
        <Modal
          title="Confirmation"
          open={isModalOpen}
          onCancel={() => setIsModal(false)}
          footer={null}
        >
          <div>
            <p className="text-primary-foreground text-lg">
              Kindly input the correct OTP to complete this process.
            </p>

            <div className="flex flex-col space-y-2 mt-3">
              <Input
                type="text"
                name="otp"
                label="OTP"
                value={otp}
                placeholder="OTP"
                onChange={(e) => setOtp(e?.target?.value)}
              />
              <Button
                className={`text-white mt-3 w-full font-bold rounded-md ease-in-out duration-300 bg-brown`}
                disabled={!otp}
                isLoading={isDelivering}
                onClick={() => {
                  deliver();
                  // mutateAsync(payload, {
                  //   onSuccess: async (data: any) => {
                  //     message.success(data?.message);
                  //     handleModalClose();
                  //     queryClient.invalidateQueries({ queryKey: [""] });
                  //     handleModalClose();
                  //   },
                  //   onError: (error: any) => {
                  //     message.error(error?.response?.data?.message);
                  //     handleModalClose();
                  //   },
                  // });
                }}
                label={"Submit"}
              />
            </div>
          </div>
          {/* <Input
              type={"text"}
              name={"name"}
              label={"name"}
              value={payload.name}
              placeholder={"Enter branch name"}
              onChange={handleInputChange}
            /> */}
        </Modal>
      </div>
      {/* <span className="w-[80px]">
            <span
              className={`text-[13px] capitalize text-center rounded-md p-[13px] ${
                orderStatus === "paid"
                  ? "bg-[#FFF5F0] text-[#FF5001]"
                  : "bg-[#EAFFEA] text-[#008000]"
              }`}
            >
              {orderStatus}
            </span>
          </span> */}
    </DriverDashboard>
  );
};

export default DriverOrderDetails;

const PhoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
      />
    </svg>
  );
};
